import { TableService } from '@app/shared/services/table.service';
import { Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { NewReminderModalComponent } from '../new-reminder-modal/new-reminder-modal.component';
import { DatePipe, formatDate } from '@angular/common';
import { InfoDialogComponent } from '../dialog/info-dialog/info-dialog.component';
import { MessageService } from '@app/shared/services/message.service';
import { ReminderService } from '@app/shared/services/reminder-service.service';

@Component({
  selector: 'ngx-view-reminders',
  templateUrl: './view-reminders.component.html',
  styleUrls: ['./view-reminders.component.scss']
})
export class ViewRemindersComponent implements OnDestroy{

  @Input() title = '';
  reminders:any = [];
  @Input() currentlyOpenedRecord = '';
  @Input() loader;
  @Input() recordObject:any = {};
  limit = 10
  @Input() unreadReminderCount = 0;
  isRecordReminder = false;
  numberOfPagesLoadedReminder = 1;
  snoozeTime;
  @Output() reminderUpdated = new EventEmitter();
  @Input() fromViewPage = true;

  constructor(private tableService: TableService,
              private dialogService: NbDialogService,
              private datePipe: DatePipe,
              private toaster: NbToastrService,
              private messageService : MessageService,
              private service : ReminderService,
           ) {
            this.reminders = [];
           }

  ngOnInit(){
    this.reminders = [];
    this.getRemindersList();
    // this.service.reminders$.subscribe((r) => {
    //   this.reminders = r;
    // });
  }

  ngOnDestroy(): void {
    this.reminders = [];
    // this.service.reminders$.next([]);
  }

  getRemindersList(skip = 0) {
    this.loader = true;
    this.service.myReminders(this.limit, skip ,this.currentlyOpenedRecord).subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.tableService.runCustomStyling();
        this.unreadReminderCount = res.data.overDueReminders;

        if (res.data.reminders) {
          this.numberOfPagesLoadedReminder++;
          if(this.reminders.length == 0){
            this.reminders = res.data.reminders;
          }else{
            let data = [...this.reminders, ...res.data.reminders]
            const uniqueData = Array.from(new Set(data.map(item => item._id)))
              .map(id => data.find(item => item._id === id));
              this.reminders = uniqueData;
          }
          this.service.reminders$.next(this.reminders);
          this.loader = false;
        }
      }
    });
  }

  formatDate(value) {
    if (!value) {
      return "";
    }
    let currentDate = new Date();
    let data = this.datePipe.transform(value, "dd/MM/YYYY");
    let current = this.datePipe.transform(currentDate, "dd/MM/YYYY");
    if (data == current) {
      return formatDate(value, "h:mm a", "en");
    }
    return formatDate(value, "M/d/yy, h:mm a", "en");
  }

  addReminder() {
    const reminerObj = {};
    if(this.fromViewPage){
      reminerObj['resourceId'] = this.currentlyOpenedRecord;
      reminerObj['tableName'] = this.recordObject?.tableName;
      reminerObj['tableId'] = this.recordObject?.tableId;
      reminerObj['IdFieldData'] = this.recordObject?.IdFieldData;
      reminerObj['fromViewPage'] = true;
      reminerObj['tableIcon'] = this.recordObject?.tableIcon,
      reminerObj['subject'] = this.recordObject?.recordData?.subject ? this.recordObject?.recordData?.subject : null;
    }
    this.dialogService
      .open(NewReminderModalComponent, {
        closeOnBackdropClick: false,
        context: {
          ...reminerObj,
          needReminder:true
        },
        autoFocus: true,
    })
    .onClose.subscribe((res) => {
      if(typeof res == 'object' && res !== null){
        this.incrementReminder(res.reminder);
      }
    });
  }

  openSnoozeModal(reminder,i) {
    this.service.openSnoozeModal(reminder,i);
  }

  openReminderModal(reminder, index? : number) {
    this.service.openReminderModal2(reminder).subscribe(value => {
      if(value){
        this.reminders[index].dueDate = value["dueDate"];
        this.reminders[index].notes = value["notes"];
        this.reminders[index].details = value["details"];
      }
    });
  }

  markComplete(reminder, i) {

    let resource = '';

    if (reminder.reminderDetails?._id) {
      resource = reminder.reminderDetails._id;
    }

    if (reminder.reminderDetails?.reminderId) {
      resource = reminder.reminderDetails.notificationId;
    }

    if (reminder.notificationId) {
      resource = reminder.notificationId;
    }

    if(!resource){
      resource = reminder._id;
    }

    this.tableService.markComplete(resource).subscribe(
      (res: any) => {
        if (res.statusCode === 200) {
          this.toaster.success("", "Reminder marked as completed sucessfully!");
        } else {
          this.toaster.danger(res.message, "Error");
        }
        this.decrementReminder(i);
      },
      (error) => {
    //    this.reminderCompleted(false);
      }
    );
  }

  incrementReminder(reminder:number){
    this.unreadReminderCount++
    this.reminderUpdated.emit(this.unreadReminderCount);
    this.reminders.push(reminder);
  }

  decrementReminder(i){
    this.unreadReminderCount--;
    this.reminderUpdated.emit(this.unreadReminderCount);
    this.reminders.splice(i, 1);
  }

  // snooze(notification,time) {
  //   return this.service.snooze(notification,time);
  // }

  deleteReminder(reminder, i) {

    const id = reminder?._id || reminder.notificationId

    this.tableService.deleteReminder(id).subscribe(
      (res: any) => {
        if (res.statusCode === 200) {
          this.toaster.success(res.message, "Success");
          this.reminders.splice(i, 1);
          this.unreadReminderCount--;
        } else {
          this.toaster.danger(res.message, "Error");
        }
      },
      (error) => {
      }
    );
  }

  deleteNotification(notification, i) {

    this.messageService.deleteMessage(notification._id).subscribe((res: any) => {
      if (res["statusCode"] == 200) {
        this.reminders.splice(i, 1);
        this.unreadReminderCount--;
        this.toaster.success(res.message, "Success");
      }
    });
  }

  scrollHandler(e){
    if(this.loader) return;
    let diff = e.srcElement.scrollTop - (e.srcElement.scrollHeight - 352);
      if (diff > 18) {
        if(this.numberOfPagesLoadedReminder * this.limit < this.unreadReminderCount){
         this.getRemindersList(this.numberOfPagesLoadedReminder * this.limit);
          e.preventDefault();
        }
      }
  }

  showReminder(reminder) {
    reminder.reminderDetails = reminder;
    this.dialogService.open(InfoDialogComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        title: ``,
        text: "",
        dialogType: "reminder",
        notification: reminder,
      },
    }).onClose.subscribe((res) => {
      if (res && res?.status == "markDone") {
        let index = this.reminders.findIndex((x) => x.notificationId == res?.data?.notificationId)
        this.reminders.splice(index, 1)

      } else if (res && res.status == "stopRecurring") {
        let index = this.reminders.findIndex((x) => x.notificationId == res?.data?.notificationId)
        this.reminders[index].frequency = null;
      }
    });
  }
}

@Component({
  selector: 'view-reminder-wrapper',
  template: `
   <nb-card class="reminder-card" >
      <nb-card-header class="text-center header-inner filled-dynamic-color reminder-header">
        Reminders ({{ unreadReminderCount }})
      </nb-card-header>

      <nb-card-body class="ScrollOut">
        <ngx-view-reminders
          [loader]="loader"
          [currentlyOpenedRecord]="currentlyOpenedRecord"
          [recordObject]="recordObject"
          (reminderUpdated) = "updateCount($event)"
          >
        </ngx-view-reminders>
      </nb-card-body>

      <nb-card-footer>
      </nb-card-footer>
    </nb-card>`,
      styleUrls: ['./view-reminders.component.scss']
    })

export class ViewReminderWrapperComponent{

  reminders = [];
  @Input() currentlyOpenedRecord;
  @Input() recordObject;
  loader = false;
  numberOfPagesLoadedReminder = 0;
  limit = 10;
  @Input() unreadReminderCount = 0;
  @Input() fromViewPage = false;

  updateCount($event){
    this.unreadReminderCount = $event;
  }
}
